
import { Component, Prop, Vue, Watch } from 'vue-property-decorator';
import { DataTableHeader } from 'vuetify';
import { LeaveRequestInterface } from '@/services/Calendar/leaves/interfaces';
import { BaseProfileDataInterface } from '@/services/Users-profile/interfaces';
import ViewLeaveRequestDialog from '@/components/dialogs/calendar/leave/ViewLeaveRequestDialog.vue';
import Themeable from 'vuetify/lib/mixins/themeable';
import {
  LIST_FOOTER_PROPS,
  ListPaginationOptions,
  defaultListOptions,
  effectivePageSize,
} from '@/utils/listPagination';

@Component({
  mixins: [
    Themeable,
  ],
  components: {
    ViewLeaveRequestDialog,
  },
})
export default class RecentLeavesComponent extends Vue {
  @Prop() private leaves!: LeaveRequestInterface[];
  @Prop() private usersMap!: { [userId: string]: BaseProfileDataInterface };
  @Prop() private totalItems!: number;
  @Prop() private loading!: boolean;

  public LIST_FOOTER_PROPS = LIST_FOOTER_PROPS;
  public options: ListPaginationOptions = defaultListOptions();

  private viewLeaveRequestDialog: string = '';
  private leaveRequestForDialog!: LeaveRequestInterface;

  private headers: DataTableHeader[] = [
    { text: 'Type', value: 'leaveType.name', sortable: false },
    { text: 'Days', value: 'days', sortable: false },
    { text: 'Dates', value: 'date', sortable: false },
    { text: 'Submitted By', value: 'requestBy', sortable: false },
    { text: 'Reviewed By', value: 'reviewedBy', sortable: false },
    { text: 'Requested On', value: 'requestOn', sortable: false },
    { text: 'Status', value: 'status', sortable: false },
    { text: 'Actions', value: 'actions', sortable: false },
  ];

  @Watch('leaves')
  private leavesUpdate(): void {
    this.$forceUpdate();
  }

  private emitChange(): void {
    this.$emit('change-page', this.options.page, effectivePageSize(this.options.itemsPerPage));
  }

  private onPageChange(): void {
    this.emitChange();
  }

  private onItemsPerPageChange(): void {
    this.options.page = 1;
    this.emitChange();
  }

  private viewLeaveRequest(leaveRequest: LeaveRequestInterface): void {
    this.viewLeaveRequestDialog = 'view-leave-request-dialog';
    this.leaveRequestForDialog = leaveRequest;
  }

  private getLeaveStatus(leaveRequest: LeaveRequestInterface): string {
    if (leaveRequest.cancellation && leaveRequest.cancellation.isApproved) {
      return 'Cancelled';
    }

    if (leaveRequest.isApproved === null) {
      return 'Pending';
    } else if (leaveRequest.isApproved) {
      return 'Approved';
    } else {
      return 'Denied';
    }
  }
}
